var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconVeganBowlColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8BC34A",
    d: "M13.194 10.694c-8.472 0-12.5-5.833-12.638-6.041-.348-.486-.209-1.111.277-1.459.486-.347 1.111-.208 1.459.278.139.209 3.958 5.764 12.222 5.07.555-.07 1.042.416 1.111.972.07.555-.417 1.042-.972 1.111-.486 0-.972.07-1.459.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BC34A",
    d: "M8.75 15.417c4.93 1.805 12.153-2.57 13.82-3.542-2.917-1.32-4.792-9.236-9.862-10.347-3.61-.764-6.25 1.041-5.625 5.903-3.194 2.36-1.805 6.666 1.667 7.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689F38",
    d: "M12.708 1.528c5.14 1.041 7.014 9.028 9.861 10.347-2.36.07-7.083-.486-15.555-4.444-.556-4.862 2.083-6.598 5.694-5.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BCD4",
    d: "M0 13.889c0 5.486 3.542 7.292 8.403 9.028h8.194C21.458 21.25 25 19.375 25 13.889H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BCD4",
    d: "M8.333 21.528h8.334v2.778H8.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006B6B",
    d: "M24.375 17.361c.417-.972.625-2.083.625-3.472H0c0 1.389.208 2.5.625 3.472h23.75z"
  }))));
}

export default SvgCommonIconVeganBowlColor;